module.exports = __webpack_public_path__ + "img/logobpb.71975306.svg";